<!-- ── Panel : KPI tiles + Add drill session, then the session table ────────── -->
<section class="holes-view__panel" data-attr="holes-panel-drilling">

  <header class="drilling-head">
    <div class="drilling-kpis" data-attr="holes-drilling-kpis">
      <div class="drilling-kpi drilling-kpi--progress" [title]="(progressPercent() | number:'1.0-0') + ' %'">
        <svg class="drilling-kpi__ring" viewBox="0 0 32 32" aria-hidden="true">
          <circle class="drilling-kpi__track" cx="16" cy="16" [attr.r]="ringRadius" />
          <circle class="drilling-kpi__value" cx="16" cy="16" [attr.r]="ringRadius"
            [attr.stroke-dasharray]="ringDash()" transform="rotate(-90 16 16)" />
        </svg>
        <div class="drilling-kpi__text">
          <span class="drilling-kpi__number">{{ totalDrilled() | number:'1.0-0' }}m / {{ targetMeters() | number:'1.0-0' }}m</span>
          <span class="drilling-kpi__label">{{ 'HOLES_TAB.DRILLING_TOTAL_DRILLED' | translate }}</span>
        </div>
      </div>

      <div class="drilling-kpi">
        <span class="drilling-kpi__number">{{ totalEngineHours() | number:'1.1-1' }} h</span>
        <span class="drilling-kpi__label">{{ 'HOLES_TAB.DRILLING_ENGINE_HOURS' | translate }}</span>
      </div>

      <div class="drilling-kpi">
        <span class="drilling-kpi__number">{{ drillingRate() | number:'1.1-1' }} m/h</span>
        <span class="drilling-kpi__label">{{ 'HOLES_TAB.DRILLING_RATE' | translate }}</span>
      </div>
    </div>

    <div class="drilling-head__actions">
      <app-button
        variant="secondary"
        size="small"
        [label]="'HOLES_TAB.DRILLING_ADD_SESSION' | translate"
        [addIconLeft]="true"
        data-attr="holes-drilling-add-btn"
        (clicked)="onAddSession()">
        <img slot="icon-left" src="assets/icon/new_icon/add_circle_black.svg" alt="">
      </app-button>
      <div class="holes-view__columns">
        <app-button-list
          [items]="allColumns"
          [selectedKeys]="visibleColumnKeys()"
          (selectionChange)="onColumnsChange($event)"
          iconSrc="assets/icon/settings.svg"
          panelTitle="QAQC_TAB.COLUMNS" />
      </div>
    </div>
  </header>

  @if (state.drillSessionsError()) {
    <div class="drilling-notice drilling-notice--error">
      <span>{{ 'HOLES_TAB.DRILLING_LOAD_ERROR' | translate }}</span>
      <button type="button" class="drilling-notice__retry" (click)="retry()">{{ 'HOLES_TAB.RETRY' | translate }}</button>
    </div>
  }
  @if (state.drillSessionSaveError()) {
    <div class="drilling-notice drilling-notice--error">
      <span>{{ 'HOLES_TAB.DRILLING_SAVE_ERROR' | translate }}</span>
    </div>
  }

  <div class="holes-view__table">

    @if (rows().length) {
      <app-data-table
        [data]="rows()"
        [columns]="visibleColumns()"
        [searchTerm]="state.searchTerm()"
        [clickable]="true"
        rowKey="id"
        highlightedRowKey="id"
        [highlightedRowValue]="state.selectedSessionId()"
        (selectionLigne)="onRowClick($event)"
        sortAscIcon="assets/icon/new_icon/arrow_full_down.svg"
        sortDescIcon="assets/icon/new_icon/arrow_full_up.svg"
        sortIconFilter="brightness(0)">
        <ng-template tableCell="shift" let-row>
          <span class="drilling-shift">{{ row.shift }}</span>
        </ng-template>
        <ng-template tableCell="date" let-row>{{ row.date | date:'dd/MM/yyyy' }}</ng-template>
        <ng-template tableCell="shiftDuration" let-row>{{ row.shiftDuration | number:'1.1-1' }} h</ng-template>
        <ng-template tableCell="engineHours" let-row>{{ row.engineHours | number:'1.1-1' }} h</ng-template>
        <ng-template tableCell="pauseHours" let-row>{{ formatPause(row.pauseHours) }}</ng-template>
        <ng-template tableCell="drilledMeters" let-row>
          <span class="drilling-progress" [title]="row.drilledMeters + ' m / ' + targetMeters() + ' m'">
            <span class="drilling-progress__track">
              <span class="drilling-progress__fill" [style.width.%]="sessionPercent(row.drilledMeters)"></span>
            </span>
            <span class="drilling-progress__text">
              <strong>{{ sessionPercent(row.drilledMeters) }}%</strong>
              <small>{{ row.drilledMeters | number:'1.0-1' }}m/{{ targetMeters() | number:'1.0-0' }}m</small>
            </span>
          </span>
        </ng-template>
        <ng-template tableCell="details" let-row>
          <button type="button" class="drilling-details" data-attr="holes-drilling-details" (click)="onDetails(row, $event)">
            {{ row.details }}
            <img src="assets/icon/new_icon/arrow-right.svg" alt="">
          </button>
        </ng-template>
      </app-data-table>
    } @else if (!state.drillSessionsLoading() && !state.drillSessionsError()) {
      <div class="holes-view__empty drilling-empty" data-attr="holes-drilling-empty">
        <p>{{ 'HOLES_TAB.DRILLING_NO_SESSIONS' | translate }}</p>
        <app-button
          variant="secondary"
          size="small"
          [label]="'HOLES_TAB.DRILLING_ADD_SESSION' | translate"
          [addIconLeft]="true"
          (clicked)="onAddSession()">
          <img slot="icon-left" src="assets/icon/new_icon/add_circle_black.svg" alt="">
        </app-button>
      </div>
    }
  </div>

</section>
